import { Select } from '@shape-ds/components';

import { useTranslation } from 'react-i18next';
import { Attribute } from '../../utils/types';
import { useChartVariables } from '../LineCharts';

interface SelectByCategoryProps {
  setValue: (value: string) => void;
  value: string;
  fullWidth?: boolean;
  tags?: { [key: string]: ChartTag[] | Attribute[] };
}

export const SelectByCategory = ({
  setValue,
  value,
  fullWidth = false,
  tags,
}: SelectByCategoryProps) => {
  const { t } = useTranslation();
  const { chartId } = useChartVariables();
  if (!tags) {
    return null;
  }
  const options = Object.keys(tags)
    .filter((category) => {
      return tags[category].some((cat) => cat.is_plottable || cat.reference) && category !== 'ALL';
    })
    .map((category) => {
      return { label: category, value: category };
    });

  const sortedOptions = [
    ...options,
    {
      label: chartId.includes('sensors')
        ? t('event_page:components.sensors_graphic.all_sensors')
        : t('event_page:components.sensors_graphic.all_features'),
      value: 'ALL',
    },
  ].sort((a, b) => {
    if (a.label === 'Sensors - Alarm') return -1;
    if (b.label === 'Sensors - Alarm') return 1;
    return a.label.localeCompare(b.label);
  });

  return (
    <Select
      data={sortedOptions}
      onChange={(event) => {
        setValue(event.target.value as string);
      }}
      className="date-filter-select"
      value={value}
      fullWidth={fullWidth}
    />
  );
};
